<template>
<div class="modal is-large" :class="{ 'is-active': active }">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="default-settings-title">
                <span class="account-name">Add Account</span>
                <span class="default-settings-subtitle">Connect a new cloud provider account.</span>
            </div>
            <!-- <div class="default-settings-description">
                In order to connect with a new account, select one of the providers below.
            </div> -->

            <div class="backup">
                <div class="columns is-multiline">
                    <div @click="selectProvider('digital_ocean')" class="column is-3">
                        <div class="backup-frequency backup-frequency-selectable" :class="{'backup-frequency-selected': selectedProvider('digital_ocean')}">
                            <div class="icon" style="margin-right: 15px;">
                                <img src="/providers/do-logo-small.png">
                                <!-- <font-awesome-icon :icon="['fab', 'digital-ocean']"/> -->
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Provider
                                </div>
                                <div class="detail-value">
                                    DigitalOcean
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div @click="selectProvider('hetzner')" class="column is-3">
                        <div class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': selectedProvider('hetzner')}">
                            <div class="icon" style="margin-right: 15px;">
                                <img src="/providers/hetzner-logo-small.png">
                                <!-- <font-awesome-icon icon="cloud"/> -->
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Provider
                                </div>
                                <div class="detail-value">
                                    Hetzner
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div @click="selectProvider('aws')" class="column is-3">
                        <div class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': selectedProvider('aws')}">
                            <div class="icon" style="margin-right: 16px;">
                                <img src="/providers/aws-logo.png">
                                <!-- <font-awesome-icon :icon="['fab', 'aws']"/> -->
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Provider
                                </div>
                                <div class="detail-value">
                                    AWS EC2
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div @click="selectProvider('aws_lightsail')" class="column is-3">
                        <div class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': selectedProvider('aws_lightsail')}">
                            <div class="icon" style="margin-right: 16px;">
                                <img src="/providers/aws-lightsail-logo.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Provider
                                </div>
                                <div class="detail-value">
                                    AWS Lightsail
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div @click="selectProvider('ovh')" class="column is-3">
                        <div class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': selectedProvider('ovh')}">
                            <div class="icon" style="margin-right: 10px;">
                                <img src="/providers/ovh-logo.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Provider
                                </div>
                                <div class="detail-value">
                                    OVH
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div @click="selectProvider('scaleway')" class="column is-3">
                        <div class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': selectedProvider('scaleway')}">
                            <div class="icon" style="margin-right: 10px;">
                                <img src="/providers/scaleway-logo.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Provider
                                </div>
                                <div class="detail-value">
                                    Scaleway
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div @click="selectProvider('upcloud')" class="column is-3">
                        <div class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': selectedProvider('upcloud')}">
                            <div class="icon" style="margin-right: 15px;">
                                <img src="/providers/upcloud-logo.png">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Provider
                                </div>
                                <div class="detail-value">
                                    UpCloud
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div @click="selectProvider('exoscale')" class="column is-3">
                        <div class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': selectedProvider('exoscale')}">
                            <div class="icon" style="margin-right: 15px;">
                                <img src="/providers/exoscale-logo.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Provider
                                </div>
                                <div class="detail-value">
                                    Exoscale
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div @click="selectProvider('gcp')" class="column is-3">
                        <div class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': selectedProvider('gcp')}">
                            <div class="icon" style="margin-right: 15px;">
                                <img src="/providers/gcp-logo.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Provider
                                </div>
                                <div class="detail-value">
                                    GCP
                                </div>
                            </diV>
                        </div>
                    </div>
                    <div @click="selectProvider('alibaba_cloud')" class="column is-3">
                        <div class="backup-retention backup-retention-selectable" :class="{'backup-frequency-selected': selectedProvider('alibaba_cloud')}">
                            <div class="icon" style="margin-right: 15px;">
                                <img src="/providers/alibaba-cloud-logo.svg">
                            </div>
                            <div class="details">
                                <div class="detail-label">
                                    Provider
                                </div>
                                <div class="detail-value">
                                    Alibaba Cloud
                                </div>
                            </diV>
                        </div>
                    </div>

                    <!-- <div class="column is-12" v-show="selectedProvider('digital_ocean')">
                        <div class="columns">
                            <div class="column is-6">
                                <div class="field">
                                    <input v-model="name" name="custom-schedule" type="text" :class="{ 'is-danger': false }" class="input custom-input-size is-medium" placeholder="Account name" autocomplete="off"/>
                                    <span v-if="true" class="help">An intuitive name for the account</span>
                                </div>
                            </div>
                            <div class="column is-6">
                                <div class="field">
                                    <input v-model="token" name="custom-schedule" type="text" :class="{ 'is-danger': true }" class="input custom-input-size is-medium" placeholder="API Key" autocomplete="off"/>
                                    <span v-if="true" class="help has-text-danger">hello</span>
                                </div>
                            </div>
                        </div>
                    </div> -->

                    <div class="column is-full" style="padding-bottom: 0; color: #353b48">
                        <span style="display:inline-block;padding-top:10px;">Details of the new {{ selectedProviderName }} account</span>
                        <!-- <span class="default-settings-subtitle">Connect a new cloud provider account.</span> -->
                    </div>

                    <div class="column is-12" v-show="selectedProvider('hetzner')">
                        <hetzner-provider></hetzner-provider>
                    </div>

                    <div class="column is-12" v-show="selectedProvider('digital_ocean')">
                        <digital-ocean-provider></digital-ocean-provider>
                    </div>

                    <div class="column is-12" v-show="selectedProvider('aws')">
                        <aws-provider></aws-provider>
                    </div>

                    <div class="column is-12" v-show="selectedProvider('aws_lightsail')">
                        <aws-lightsail-provider></aws-lightsail-provider>
                    </div>
                    
                    <div class="column is-12" v-show="selectedProvider('ovh')">
                        <ovh-provider></ovh-provider>
                    </div>
                    
                    <div class="column is-12" v-show="selectedProvider('upcloud')">
                        <upcloud-provider></upcloud-provider>
                    </div>
                    
                    <div class="column is-12" v-show="selectedProvider('gcp')">
                        <gcp-provider></gcp-provider>
                    </div>

                    <div class="column is-12" v-show="selectedProvider('alibaba_cloud')">
                        <alibaba-cloud-provider></alibaba-cloud-provider>
                    </div>
                    
                    <div class="column is-12" v-show="selectedProvider('scaleway')">
                        <scaleway-provider></scaleway-provider>
                    </div>
                    
                    <div class="column is-12" v-show="selectedProvider('exoscale')">
                        <exoscale-provider></exoscale-provider>
                    </div>
                </div>
            </div>

            <div class="columns is-multiline">
                <div class="column is-3">
                    <div @click="emitCreateAccountEvent" :disabled="creatingAccount" :class="{ 'is-loading': creatingAccount }" class="button custom-button-size is-fullwidth is-info">Save</div>
                </div>
                <div class="column is-3">
                    <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger" :disabled="creatingAccount">Cancel</div>
                </div>
            </div>
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';
// import FormErrorsMixin from '@/mixins/FormErrors';

export default {
    components: {
        'digital-ocean-provider': require('@/components/Accounts/Providers/DigitalOcean.vue').default,
        'hetzner-provider': require('@/components/Accounts/Providers/Hetzner.vue').default,
        'aws-provider': require('@/components/Accounts/Providers/Aws.vue').default,
        'aws-lightsail-provider': require('@/components/Accounts/Providers/AwsLightsail.vue').default,
        'ovh-provider': require('@/components/Accounts/Providers/Ovh.vue').default,
        'upcloud-provider': require('@/components/Accounts/Providers/Upcloud.vue').default,
        'gcp-provider': require('@/components/Accounts/Providers/Gcp.vue').default,
        'alibaba-cloud-provider': require('@/components/Accounts/Providers/AlibabaCloud.vue').default,
        'scaleway-provider': require('@/components/Accounts/Providers/Scaleway.vue').default,
        'exoscale-provider': require('@/components/Accounts/Providers/Exoscale.vue').default,
    },

    data() {
        return {
            active: false,
            name: '',
            token: '',
            providerSlug: 'digital_ocean',
            creatingAccount: false,
        }
    },

    mounted() {
        this.listenEvents();
    },

    methods: {
        // addAccount() {
        //     Api().post('accounts')
        //         .then(response => {
        //
        //         })
        //         .catch(error => {
        //
        //         })
        //         .finally(() => {
        //             //
        //         })
        //     ;
        // },

        emitCreateAccountEvent() {
            Event.$emit('createProviderAccount', this.providerSlug);
        },

        close() {
            if (!this.creatingAccount) {
                this.active = false;
                Event.$emit('addAccountClosed');
            }
        },

        listenEvents() {
            var vm = this;

            Event.$on('showAddAccount', () => {
                vm.active = true;
            });

            Event.$on('creatingAccountLoaderUpdated', (creatingAccount) => {
                vm.creatingAccount = creatingAccount;
            });

            Event.$on('closeAddAccount', () => {
                vm.close();
            });
        },

        selectedProvider(providerSlug) {
            return this.providerSlug === providerSlug;
        },

        selectProvider(providerSlug) {
            this.providerSlug = providerSlug;
        },
    },

    computed: {
        selectedProviderName() {
            if (this.providerSlug == 'digital_ocean') {
                return 'DigitalOcean';
            }
            if (this.providerSlug == 'hetzner') {
                return 'Hetzner';
            }
            if (this.providerSlug == 'aws') {
                return 'Amazon Web Services';
            }
            if (this.providerSlug == 'aws_lightsail') {
                return 'AWS Lightsail';
            }
            if (this.providerSlug == 'ovh') {
                return 'OVH';
            }
            if (this.providerSlug == 'scaleway') {
                return 'Scaleway';
            }
            if (this.providerSlug == 'upcloud') {
                return 'UpCloud';
            }
            if (this.providerSlug == 'gcp') {
                return 'Google Cloud Platform';
            }
            if (this.providerSlug == 'alibaba_cloud') {
                return 'Alibaba Cloud';
            }
        },
    },
}
</script>
